import type { Types as CommunicationChannelTypes } from '@/entities/communication-channel';
import type { Types as CommunicationChannelOperatorTypes } from '@/entities/communication-channel-operator';

import type { Types as ModuleTypes } from '@/entities/module';
import type { ICompany as ICoverCompany } from '@cover/types';
import type { ICustomPage } from '@/entities/custom-page';

export type ICommunicationChannel = CommunicationChannelTypes.IBaseCommunicationChannel;

export type IFileStorageQuota = {
  usage: string;
  total: string;
};

export type IContactField = {
  name: string;
  title: string;
  type: string;
  value: string;
  order: string;
  isEnabled: string;
};

export type IDomain = {
  domain: string;
  metricYandex: string;
  yandexMapsApiKey: string;
  name: string;
  delegate: boolean;
};

export type ISeo = {
  name: string;
  value: string;
  page?: string;
};

export type IDomainSettingsCreateUpdate = {
  metricYandex: string;
  yandexMapsApiKey: string;
};

export type IDomainCreateUpdate = {
  name: string;
  delegate: boolean;
};

export type IFavicon = {
  id: string;
  base64Data: string;
  imageUrl: string;
};

export enum EAuthMethods {
  phone = 'phone',
  motmom = 'motmom',
}

export type IAuthMethods = {
  id: string;
  authType: EAuthMethods;
};

enum ESectionsPosition {
  left = 'left',
  right = 'right',
  center = 'center',
}

export type ICompany = {
  id: string;
  login: string;
  name: string;
  headerSubtitle: string;
  coverTitle: string;
  coverSubtitle: string;
  coverUrl: string;
  isEditingFromCvs: boolean;
  isHumanSite: boolean;
  mainCustomPageId: string;
  headerCustomPageId: string;
  footerCustomPageId: string;
  phone: string;
  email: string;
  headerSectionsPosition: ESectionsPosition;
  isPublished: boolean;
  isBlocked: boolean;

  communicationChannelOperators?: CommunicationChannelOperatorTypes.ICommunicationChannelOperator[];
  communicationChannels?: CommunicationChannelTypes.IBaseCommunicationChannel[];
  logoUrl?: string;
  mainCustomPage?: ICustomPage;
  headerCustomPage?: ICustomPage | null;
  footerCustomPage?: ICustomPage | null;
  customPages?: ICustomPage[];
  fileStorageQuota?: IFileStorageQuota;
  favicon?: IFavicon;
  domain?: IDomain;
  seo?: ISeo[];
  authMethods?: IAuthMethods[];
  legalName?: string;
  modules?: ModuleTypes.IModule[];
} & ICoverCompany;

export type ICompanyStore = {
  company: ICompany | null;
};
